import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GameProvider } from "@/context/GameContext";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          background: "#0a0502", color: "#F1E194",
          fontFamily: "Cairo, sans-serif", gap: "16px", padding: "24px",
          textAlign: "center",
        }}>
          <span style={{ fontSize: "2.5rem" }}>⚠️</span>
          <p style={{ fontSize: "1.1rem", fontWeight: 700, margin: 0 }}>حدث خطأ غير متوقع</p>
          <p style={{ fontSize: "0.85rem", color: "rgba(241,225,148,0.55)", margin: 0 }}>
            {this.state.error?.message || "يرجى إعادة تحميل الصفحة"}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "8px", padding: "10px 28px", borderRadius: "10px",
              background: "#5B0E14", border: "1.5px solid #F1E194",
              color: "#F1E194", fontFamily: "Cairo, sans-serif",
              fontSize: "0.95rem", fontWeight: 700, cursor: "pointer",
            }}
          >
            إعادة تحميل
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import GameModeSelectPage from "@/pages/GameModeSelectPage";
import TeamSetupPage from "@/pages/TeamSetupPage";
import TournamentSetupPage from "@/pages/TournamentSetupPage";
import TournamentBracketPage from "@/pages/TournamentBracketPage";
import CategorySelectPage from "@/pages/CategorySelectPage";
import GameBoardPage from "@/pages/GameBoardPage";
import QuestionPage from "@/pages/QuestionPage";
import SecretWordPage from "@/pages/SecretWordPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import StudioLoginPage from "@/pages/StudioLoginPage";
import StudioPage from "@/pages/StudioPage";
import CommunityPage from "@/pages/CommunityPage";
import ProfilePage from "@/pages/ProfilePage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import MyGamesPage from "@/pages/MyGamesPage";
import PreparationScreen from "@/pages/PreparationScreen";
import UsernameSetupPage from "@/pages/UsernameSetupPage";

function App() {
  return (
    <ErrorBoundary>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <GameProvider>
      <div className="App" dir="rtl">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/canceled" element={<PaymentSuccessPage />} />
            <Route path="/mode" element={<GameModeSelectPage />} />
            <Route path="/setup" element={<TeamSetupPage />} />
            <Route path="/tournament" element={<TournamentSetupPage />} />
            <Route path="/tournament/bracket" element={<TournamentBracketPage />} />
            <Route path="/categories" element={<CategorySelectPage />} />
            <Route path="/prepare" element={<PreparationScreen />} />
            <Route path="/game" element={<GameBoardPage />} />
            <Route path="/question" element={<QuestionPage />} />
            <Route path="/secret/:questionId" element={<SecretWordPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/studio" element={<StudioLoginPage />} />
            <Route path="/studio/dashboard" element={<StudioPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/:username" element={<ProfilePage />} />
            <Route path="/my-games" element={<MyGamesPage />} />
            <Route path="/username-setup" element={<UsernameSetupPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </GameProvider>
    </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
